import { CSVImportWizard } from '../components/Import';
import { Upload } from 'lucide-react';

export function ImportPage() {
  return (
    <div className="h-full flex flex-col animate-fadeIn">
      <div className="max-w-(--breakpoint-2xl) mx-auto w-full p-6 flex-1">
        <div className="mb-6 animate-slideDown">
          <div className="flex items-center gap-3 mb-2">
            <Upload className="w-8 h-8 text-dark-accent" />
            <h1 className="text-2xl font-bold text-dark-text-primary tracking-tight">
              Import Data
            </h1>
          </div>
          <p className="text-sm text-dark-text-secondary">
            Import venues and contacts from a CSV file
          </p>
        </div>

        <div className="card animate-scaleIn">
          <CSVImportWizard isOpen={true} onClose={() => {}} embedded />
        </div>
      </div>
    </div>
  );
}
